/**
 * Toast Service — API portada do ElevaChecks (success/error/warning/info,
 * utilizável fora do React, ex.: interceptors). A renderização delega no
 * sistema de toasts shadcn que o PadelMaster já tem montado no main.tsx
 * (components/ui/toaster) — sem segundo sistema de toasts.
 */
import { toast } from '@/hooks/use-toast';

export const toastService = {
  success(message: string) {
    toast({ description: `✅ ${message}` });
  },

  error(message: string) {
    toast({ variant: 'destructive', description: message });
  },

  warning(message: string) {
    toast({ description: `⚠️ ${message}` });
  },

  info(message: string) {
    toast({ description: `ℹ️ ${message}` });
  },
};
